import { DocumentPreviewDrawerTabProps } from './DocumentPreviewDrawerTab.props';
import { ImageViewerTab } from './image-viewer/ImageViewerTab';
import { MarkdownViewerTab } from './markdown-viewer/MarkdownViewerTab';
import PDFViewerTab from './pdf-viewer/PDFViewerTab';
import XLSXViewerTab from './xlsx-viewer/XLSXViewerTab';
import { FileModel } from '../../../api';

const DocumentPreviewDrawerTab = ({ document, companyId }: DocumentPreviewDrawerTabProps) => {
  switch (document.file.file_type) {
    case FileModel.file_type.PDF:
      return <PDFViewerTab document={document} companyId={companyId} />;
    case FileModel.file_type.XLSX:
      return <XLSXViewerTab document={document} />;
    case FileModel.file_type.PNG:
    case FileModel.file_type.JPEG:
    case FileModel.file_type.JPG:
      return <ImageViewerTab document={document} />;
    case FileModel.file_type.MD:
      return <MarkdownViewerTab document={document} />;
    default:
      return <div>DocumentPreviewDrawerTab</div>;
  }
};

export default DocumentPreviewDrawerTab;
